import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { debounceTime, first, fromEvent, map } from 'rxjs';
import { SignificantTermList } from 'src/app/core/models';
import { DashboardService } from 'src/app/services/dashboard.service';
import { UtilsService } from 'src/app/services/utils.service';
import { SearchableAlphabets } from 'src/app/core/constants';
import { SearchableAlphabetsPa } from 'src/app/core/constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-significant-terms',
  templateUrl: './significant-terms.component.html',
  styleUrls: ['./significant-terms.component.scss'],
})
export class SignificantTermsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('searchInput') searchInput: ElementRef | undefined;
  isHandsetPortrait: boolean = false;

  bannerImage: any ='';
  bannerClass: any ='';
  isSignificantTermsLoading: boolean = false;
  significantTerms: SignificantTermList[] = [];
  totalTerms: number = 0;
  searchableAlphabets: string[] = SearchableAlphabets;
  searchableAlphabetsPa: string[] = SearchableAlphabetsPa;
  activeAlphabetCriteriaIndex: number = 0;
  hashtagSearch: string = '';
  closeResultsCount: boolean = false;
  searchTerm: string = '';
  availableInitials: string[] = [];
  unavailableCharsArray: string[] = [];
  constructor(
    private dashboardService: DashboardService,
    private router: Router,
    private utils: UtilsService
  ) {}

  ngOnInit(): void {

    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;
    let currentLanguage = localStorage.getItem('language');
    if(currentLanguage){
      this.searchableAlphabets =
        currentLanguage === 'en'
        ? this.searchableAlphabets
        : this.searchableAlphabetsPa;
    }
    let index = sessionStorage.getItem('glossaryIndex')
    if(index){
      this.activeAlphabetCriteriaIndex = +index
    }

    this.fetchSignificantTermsList();
  }

  ngAfterViewInit() {
    const searchKeyUp$ = fromEvent(this.searchInput?.nativeElement, 'keyup');
    searchKeyUp$
      .pipe(
        map((i: any) => i.currentTarget.value),
        debounceTime(500)
      )
      .subscribe({
        next: (searchedTerm: string) => {
          this.activeAlphabetCriteriaIndex = 0;
          this.hashtagSearch = '';
          this.fetchSignificantTermsList();
        },
        error: (keyUpError) => {
          // console.log('key up error ', keyUpError);
        },
      });
  }

  fetchSignificantTermsList() {
    this.isSignificantTermsLoading = true;
    this.dashboardService
      .fetchSignificantTermsList(
        this.isHandsetPortrait,
        this.activeAlphabetCriteriaIndex,
        this.hashtagSearch,
        this.searchTerm
      )
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.isSignificantTermsLoading = false;
          this.significantTerms = res?.value?.length ? res.value : [];
          this.totalTerms = this.significantTerms.length;

          // sort sections in descreasing increasing order by WordID
          this.significantTerms =
            this.significantTerms.sort(
              (a: any, b: any) =>
                a.WordName > b.WordName ? 1 : -1
            );
          if (
            !this.activeAlphabetCriteriaIndex &&
            this.significantTerms.length
          ) {
            this.unavailableCharsArray =
              this.utils.createUnavailableCharsArrayFromProperty(
                'WordName',
                this.significantTerms
              );
          }
        },
        error: (e: any) => {
          this.significantTerms = [];
          // console.error('error in fetching significantTerms', e);
        },
      });
  }

  fetchTags(attributesString: string) {
    let attributesArray: any[] = [];

    if (attributesString?.trim() && attributesString?.length) {
      attributesArray = attributesString?.split(',');
    }
    return attributesArray;
  }

  setAlphabetCriteria(activeIndex: number) {
    // console.log(this.unavailableCharsArray.indexOf(this.searchableAlphabets[activeIndex]));
    if (this.unavailableCharsArray.indexOf(this.searchableAlphabets[activeIndex]) !== -1)
    return;
    
    if (this.activeAlphabetCriteriaIndex !== activeIndex) {
      this.activeAlphabetCriteriaIndex = activeIndex;
    }
    sessionStorage.setItem('glossaryIndex',activeIndex.toString());
    this.fetchSignificantTermsList();
  }

  searchByHashtag(hashtag: string,e:Event) {
    e.stopPropagation();
    this.hashtagSearch = hashtag;
    this.activeAlphabetCriteriaIndex = 0;
    this.fetchSignificantTermsList();
  }

  goToTermDetail(termName: string) {
    this.router.navigate(['/significant-term-detail', termName]);
  }

  showSmallerIntroductionString(descriptionText: string | undefined) {
    return this.utils.showSmallerTermString(descriptionText);
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }

  ngOnDestroy(){
    // sessionStorage.removeItem('glossaryIndex');
  }
}
